export const environment = {
    API_URL: 'https://apis.humana.com/V1/ESNGetApplications/application-status',
    SCM_CREATE_APP_OFFLINE: 0,
    WEBSITE_RUN_FROM_PACKAGE: 1,

    sso_AUTH_URL: 'https://auth.humana.com/auth/oauth2/realms/root/realms/company_realm/.well-known/openid-configuration',
    sso_redirect_uri: 'https://ens-appstatustracker.humana.com/callback',
    sso_Content_Type: "application/x-www-form-urlencoded",
    sso_client_id: 'SMS_Self_Service_Tool_PROD',
    sso_scope: 'openid profile authz email',
    sso_sessionStorage: 'oidc.user:https://auth.humana.com/auth/oauth2/realms/root/realms/company_realm/.well-known/openid-configuration:SMS_Self_Service_Tool_PROD',

    apigee_apikey: 'i7tLb291H8QnCzLXYN9vFxcUwEas70m8sGS2BbTEimGB4dPZ',
  
    CHROME_BIN:'C:/Program Files/Google/Chrome/Application/chrome.exe'
};